export default [
  {
    path: "/dashboard/analytics",
    name: "dashboard-analytics",
    component: () => import("@/views/dashboard/analytics/Analytics.vue"),
    meta: {
      resource: "IncomeOutcomeTransaction",
      action: "GetChartGeneral",
    },
  },
  {
    path: "/dashboard/analytics/income-source-percentage",
    name: "analytics-income-source-percentage",
    component: () =>
      import("@/views/apps/Analytics/IncomeSourcePercentage.vue"),
    meta: {
      resource: "IncomeOutcomeTransaction",
      action: "GetChartGeneral",
    },
  },
  {
    path: "/dashboard/analytics/income-source-cash",
    name: "analytics-income-source-cash",
    component: () => import("@/views/apps/Analytics/IncomeSourceCash.vue"),
    meta: {
      resource: "IncomeOutcomeTransaction",
      action: "GetChartGeneral",
    },
  },
  {
    path: "/dashboard/analytics/reservation-count-by-category",
    name: "analytics-reservation-count-by-category",
    component: () =>
      import("@/views/apps/Analytics/ReservationCountByPriceCategory.vue"),
    meta: {
      resource: "IncomeOutcomeTransaction",
      action: "GetChartGeneral",
    },
  },
  {
    path: "/dashboard/analytics/user-activities-by-period",
    name: "analytics-user-activities-by-period",
    component: () => import("@/views/apps/Analytics/UserActivityReport.vue"),
    meta: {
      resource: "Users",
      action: "GetUsersActivitiesReportByDateTime",
    },
  },
  {
    path: "/dashboard/analytics/reservation-count-by-weekday",
    name: "analytics-reservation-count-by-weekday",
    component: () =>
      import("@/views/apps/Analytics/ReservationCountByWeekday.vue"),
    meta: {
      resource: "UserReport",
      action: "GetMostSchaduleCountByDayOfWeek",
    },
  },
  {
    path: "/dashboard/analytics/user-reports-by-period",
    name: "analytics-user-reports-by-period",
    component: () =>
      import("@/views/components/Reports/UserReportsByDateTime.vue"),
    meta: {
      resource: "Users",
      action: "GetUsersReportByDateTime",
    },
  },
  {
    path: "/dashboard/ecommerce",
    name: "dashboard-ecommerce",
    component: () => import("@/views/dashboard/ecommerce/Ecommerce.vue"),
    meta: {
      resource: "common",
      action: "common",
    },
  },
];
